export default __webpack_public_path__ + "static/media/ic-transactions.4ef63523.svg";